'use client';

import { cn } from '@scatterlab/zeta-core';
import {
  memo,
  PropsWithChildren,
  ReactNode,
  RefAttributes,
  RefObject,
} from 'react';

import { ArrowDown16Icon } from './icons';

export type CollapseRef = {
  open: boolean;
};

export type CollapseProps = PropsWithChildren<{
  title: string;
  containerClassName?: string;
  titleClassName?: string;
  summaryClassName?: string;
  iconClassName?: string;
  className?: string;
  onToggle?: (open: boolean) => void;
  rightElement?: ReactNode;
  open?: boolean;
}> &
  RefAttributes<CollapseRef>;

const Collapse = ({
  children,
  title,
  containerClassName,
  titleClassName,
  summaryClassName,
  iconClassName,
  className,
  onToggle,
  rightElement,
  open,
  ref,
}: CollapseProps) => (
  <details
    ref={ref as RefObject<HTMLDetailsElement>}
    className={cn(
      'group flex flex-col bg-white/[8%] px-4 outline-none backdrop-blur-48',
      containerClassName,
    )}
    onToggle={(event) => onToggle?.(event.currentTarget.open)}
    open={open}
  >
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
    <summary
      tabIndex={-1}
      className={cn(
        'flex cursor-pointer flex-row justify-between',
        summaryClassName,
      )}
    >
      <h5 className={cn('body14 select-none', titleClassName)}>{title}</h5>
      <div className="flex flex-row items-center gap-2">
        {rightElement}
        <ArrowDown16Icon
          className={cn(
            'block size-4 text-white group-open:rotate-180',
            iconClassName,
          )}
        />
      </div>
    </summary>
    <div className={cn('flex flex-1 pt-4', className)}>{children}</div>
  </details>
);

export default memo(Collapse);
